export default __webpack_public_path__ + "static/video-thumbnail-c0312479c0f5d8eb5a167c40716b247a.jpg";